import {inject, IReactComponent} from 'mobx-react';
import {SimpleModal} from '../../../../../../../components/simple-modal/component';

const mapStoresToProps = (stores: any) => ({
    ctrl: stores.multipartyDashboardStore.sessionEndModalController
});

export const EndMeetingModal = inject(mapStoresToProps)(SimpleModal) as IReactComponent;
